"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Shield, TrendingUp, Handshake } from "lucide-react";
const features = [{
  icon: Shield,
  title: "Buyer Protection",
  description: "Secure transactions with comprehensive verification and escrow services ensuring your investment is protected throughout the process."
}, {
  icon: Handshake,
  title: "Shared Features",
  description: "Transparent communication platform, detailed documentation access, and professional mediation support for seamless collaboration."
}, {
  icon: TrendingUp,
  title: "Seller Advantages",
  description: "Maximum market exposure, qualified buyer matching, and streamlined due diligence process to expedite your business sale."
}];
export default function KeyFeaturesComparison() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section id="key-features-comparison" className="py-20 px-4 bg-background">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          const isCenter = i === 1;
          return <div key={i} data-index={i} ref={refs[i]} className={`transition-all duration-500 ${visibilities[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className={`h-full hover-lift ${isCenter ? "border-t-2 border-t-accent" : ""}`}>
                  <CardHeader className="text-center">
                    <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary-light">
                      <Icon className="h-8 w-8 text-primary" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-xl font-display text-foreground">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground text-center leading-relaxed">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}